export default __webpack_public_path__ + "static/media/print_icon_black.b414c277.png";